// extracted by mini-css-extract-plugin
export default {"ContainerMobile":"CollapseModule_ContainerMobile__17thH","ContainerDesktop":"CollapseModule_ContainerDesktop__Eb4r5","Collapse":"CollapseModule_Collapse__mKihO"};